import useIsMetamaskEnabled from "@casino/legacy/client/features/Metamask/hooks/useIsMetamaskEnabled";
import useConnectionOrder from "./useConnectionOrder";

type Connections = SocialConnection[];

const useSortedConnections = (connections?: Connections) => {
  const isMetamaskEnabled = useIsMetamaskEnabled();

  const order = useConnectionOrder();
  const connectionsCopy = isMetamaskEnabled
    ? connections?.slice(0)
    : connections?.slice(0).filter((item) => item.handle !== "metamask");
  return connectionsCopy?.sort((prev, next) => {
    const prevIndex = order.indexOf(prev.handle as Connection);
    const nextIndex = order.indexOf(next.handle as Connection);
    return prevIndex - nextIndex;
  });
};

export default useSortedConnections;
